import dashboardService from "../../../services/dashboardService";

const { addBlock, addBlockGrid, editBlock, editBlockGrid, editBlockV1 } = dashboardService;

async function addDashboardBlock(dataToSend) {
    let res = dataToSend.type == 0 ? await addDashboardSimpleBlock(dataToSend) : await addDashboardGridBlock(dataToSend);
    return { "response": res, "titlePopup": "Block added", "bodyPopup": 'The block ' + res.name + " has been added ! " }
}
async function addDashboardSimpleBlock(dataToSend) {
    //delete dataToSend.empty;
    delete dataToSend.type_variable;
    const [response, errors] = await addBlock(dataToSend)
    if (errors != null) {
        console.log(errors)
        return;
    }
    return response;
}

async function addDashboardGridBlock(dataToSend) {
    dataToSend = getVariableTypeModification(dataToSend);
    const [response, errors] = await addBlockGrid(dataToSend);
    if (errors != null) {
        console.log(errors)
        return;
    }
    return response;
}

async function updateDashboardBlock(dataToSend, block) {
    let res = dataToSend.type == 0 ? await updateSimpleBlock(dataToSend, block.id) : await updateGridBlock(dataToSend, block);
    return { "response": res, "titlePopup": "Block edited", "bodyPopup": 'The block ' + res.name + " has been edited ! " }
}

async function updateSimpleBlock(dataToSend, block_id) {
    delete dataToSend.type_variable;
    const [response, errors] = await editBlock(block_id, dataToSend)
    if (errors != null) {
        console.log(errors)
        return;
    }
    return response;
}

async function updateGridBlock(dataToSend, block) {

    dataToSend = getVariableTypeModification(dataToSend, block.grid);
    const [response, errors] = await editBlockGrid(block.id, dataToSend)
    if (errors != null) {
        console.log(errors)
        return;
    }
    return response;
}

function getVariableTypeModification(dataToSend, grid = null) {
    if (dataToSend.type_variable != 1 && dataToSend.type_variable != 2 && dataToSend.placeholder_format == null) {
        dataToSend.placeholder_format = "";
    }
    if (dataToSend.type_variable == 0) { // checkbox
        dataToSend.placeholder_format = grid?.placeholder_format; // null ou l'ancien
        dataToSend.default_value = dataToSend.default_value_checkbox == undefined ? (grid && grid.type_variable == 0 ? grid.default_value : false) : dataToSend.default_value_checkbox;
    }
    if (dataToSend.type_variable == 1) { // input

        if (dataToSend.placeholder_format == null) {
            dataToSend.placeholder_format = grid?.placeholder_format;
        }
        if (dataToSend.regex == null) {
            dataToSend.regex = grid?.regex;
        }
    }
    if (dataToSend.type_variable == 2) { // dropdown
        dataToSend.default_value = dataToSend.default_value_dropdown;
        dataToSend.placeholder_format = dataToSend.value_dropdown;
    }
    if (dataToSend.type_variable == 4) { // number
        dataToSend.default_value = dataToSend.default_value_number;
    }
    if (grid == null) { // if block is empty, fill the array of cells
        dataToSend.structure.cells = new Array(dataToSend.structure.rows.length * dataToSend.structure.columns.length).fill({ value: dataToSend.default_value, active: true })
    }
    return dataToSend;
}
export { addDashboardBlock, updateDashboardBlock }